import React from 'react';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import OpenNoNeedRadioButton from '../OpenNoNeedRadioButton';
import BasicFormData from '../BasicFormData/BasicFormData';
import SendEmail from '../SendEmail';

export default class ConsultationForm extends React.Component {
  state = {
    name: '',
    ico: '',
    jednotka: '',
    tel: '',
    email: '',
    notes: '',
    open: 'ano',
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleOpenNoNeed = (event) => {
    this.setState({ open: event.target.value });
  };

  render() {
    const { ico, jednotka, name, tel, email, notes, open } = this.state;

    const data = {
      formName: 'Konzultace',
      jmeno: name,
      ico,
      jednotka,
      tel,
      email,
      notes,
    };

    return (
      <PageContainer>
        <h1>Sjednání konzultace</h1>
        <Form>
          <form noValidate autoComplete='off'>
            <BasicFormData
              ico={ico}
              jednotka={jednotka}
              name={name}
              tel={tel}
              email={email}
              onChange={this.handleChange}
            />
            <OpenNoNeedRadioButton open={open} onOpenNoNeed={this.handleOpenNoNeed} />
            {open === 'ano' ? (
              <TextField
                id='notes'
                label='Vaše poznámky k požadované konzultaci'
                value={notes}
                onChange={this.handleChange('notes')}
                variant='outlined'
                fullWidth
                margin='dense'
                multiline
                rowsMax='4'
              />
            ) : null}
            <SendEmail data={data} disabled={(name && ico && jednotka && tel && email).length < 1} />
          </form>
        </Form>
      </PageContainer>
    );
  }
}

const Form = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;
const PageContainer = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  h1 {
    margin-bottom: 12px;
  }
  @media (max-width: 450px) {
    padding: 24px 2%;
  }
`;
